module.exports = __webpack_public_path__ + "static/media/apartment (1).b16b7e13.png";